(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-ampoule-carousel"] && !Shopify.designMode) return;
  try {
    
if (!window.aeraAmpouleCarouselReady) {
window.aeraAmpouleCarouselReady = true;
document.addEventListener('click',function(event) {
  var button=event.target.closest('[data-ampoule-arrow]');
  if(!button)return;
  var root=button.closest('.at-ampoule');
  var track=root&&root.querySelector('[data-ampoule-track]');
  if(!track)return;
  var card=track.querySelector('.at-ampoule__card');
  if(!card)return;
  var direction=Number(button.getAttribute('data-ampoule-arrow'))||1;
  var width=card.getBoundingClientRect().width;
  var gap=parseFloat(window.getComputedStyle(track).gap)||0;
  track.scrollBy({left:direction*(width+gap),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
});
document.addEventListener('scroll',function(event){
  var track=event.target;
  if(!track || !track.matches || !track.matches('[data-ampoule-track]'))return;
  var root=track.closest('.at-ampoule');
  if(!root)return;
  var width=track.querySelector('.at-ampoule__card')?.getBoundingClientRect().width||1;
  var gap=parseFloat(window.getComputedStyle(track).gap)||0;
  var index=Math.max(1,Math.min(3,Math.round(track.scrollLeft/(width+gap))+1));
  var counter=root.querySelector('[data-ampoule-current]');
  if(counter)counter.textContent=String(index).padStart(2,'0');
},true);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.ac-masthead details[open]').forEach((menu) => {
    menu.removeAttribute('open');
    menu.querySelector('summary').focus();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
